import { FormattedMessage } from 'react-intl';
import Modal from '@/components/Modal/Modal';
import Button from '@/components/Button/Button';

const RemoveFilesConfirmModal = ({
  open,
  count,
  loading,
  onCancel,
  onConfirm,
}: {
  open: boolean;
  count: number;
  loading?: boolean;
  onCancel: () => void;
  onConfirm: () => void;
}) => {
  return (
    <Modal
      open={open}
      onClose={onCancel}
      isActionBusy={loading}
      title={
        <FormattedMessage
          id="removeFilesTitle"
          defaultMessage="Remove files"
        />
      }
      actions={
        <>
          <Button
            variant="text"
            onClick={onCancel}
            disabled={loading}
            aria-label="Cancel Button"
          >
            <FormattedMessage id="cancel" defaultMessage="Cancel" />
          </Button>
          <Button
            variant="contained"
            onClick={onConfirm}
            loading={loading}
            aria-label="Remove Button"
          >
            <FormattedMessage id="remove" defaultMessage="Remove" />
          </Button>
        </>
      }
    >
      <FormattedMessage
        id="removeFilesConfirmMessage"
        defaultMessage="You’re about to remove {count} selected files. This action cannot be undone."
        values={{ count }}
      />
    </Modal>
  );
};

export default RemoveFilesConfirmModal;
